<template>
    <Content>
        <secondary-title>{{ categoryQuestion.name }}</secondary-title>
        <div class="questions">
            <details v-for="q in categoryQuestion.questions" :key="q.id" open>
                <summary>
                    {{ q.question }}
                    <i class="icon-angle-left"></i>
                </summary>
                <ol class="answers">
                    <li
                        v-for="(a, key) in q.answers"
                        :key="`${q.id}-${key}`"
                        @click.prevent="handleSelectAnswer(q, a)"
                    >
                        <div>
                            <div class="checkbox">
                                <i
                                    :class="[
                                        'icon',
                                        a.checked && 'fas fa-check'
                                    ]"
                                ></i>
                            </div>
                            {{ a.answer }}
                        </div>
                        <img
                            v-if="a.path_image"
                            :src="a.path_image"
                            :alt="a.answer"
                        />
                    </li>
                </ol>
            </details>
        </div>
    </Content>
</template>

<script>
import { CSecondaryTitle } from "../../../components/Styles/Components/styled";
import { Content } from "./style";

export default {
    name: "QuestionCategory",
    props: {
        categoryQuestion: {
            required: true
        }
    },
    components: {
        Content,
        "secondary-title": CSecondaryTitle
    },
    methods: {
        handleSelectAnswer(q, a) {
            if (!q.multiple_answer) {
                q.answers.map(answer => (answer.checked = false));
            }
            a.checked = !a.checked;
        }
    }
};
</script>
